import VueI18n from 'vue-i18n'

import en from '../../locales/en_US.json'
import fr from '../../locales/fr_FR.json'

export const createI18n = () => {
  return new VueI18n({
    locale: 'fr',
    fallbackLocale: 'fr',
    messages: {
      fr,
      en,
    },
  })
}
